import React, { createContext, useState } from 'react';
import { bcApi } from '../helpers/bigcommerce';

const ReviewContext = createContext();

const initialState = {
  open: false
};

export const ReviewProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const showReviewForm = (open = true) => {
    setState({ ...state, open: open });
  };

  const addReview = async (product_id, data) => {
    return new Promise(async (res, rej) => {
      const endpoint = `catalog/products/${product_id}/reviews`;
      const reqBody = data;
      try {
        const { status } = await bcApi(endpoint, 'POST', reqBody);

        if (status === 200) {
          res(true);
        }
      } catch (error) {
        setState({ ...state, cartLoading: false, cartError: error });
        rej(error);
      }
    });
  };

  const getReviews = async (product_id, page, reviewId = null) => {
    let endpoint = `catalog/products/${product_id}/reviews?limit=2&page=${page}`;
    try {
      const reviews = await bcApi(endpoint, 'GET');

      if (reviews.status !== 200 || !reviews.response?.data) {
        setState({ ...state, cartLoading: false, cartError: 'Something went wrong!' });
        return false;
      }

      let reviewData = reviews.response;
      const isFirstPage = page === reviewData.meta?.pagination.total_pages;

      if (reviewId) {
        if (!isFirstPage) {
          reviewData.data = reviewData.data.filter(review => review.id !== Number(reviewId));
          return reviewData;
        }

        const existReview = reviewData.data.find(review => review.id === reviewId);
        if (!existReview && isFirstPage) {
          const review = await bcApi(
            `catalog/products/${product_id}/reviews?id=${reviewId}`,
            'GET'
          );

          if (review.status === 200 && Array.isArray(review.response?.data)) {
            reviewData.data = [...reviewData.data, ...review.response.data];
          }
        }
      }
      return reviewData;
    } catch (error) {
      setState({ ...state, cartLoading: false, cartError: error });
    }
  };

  return (
    <ReviewContext.Provider
      value={{
        state,
        setState,
        addReview,
        showReviewForm,
        getReviews
      }}
    >
      {children}
    </ReviewContext.Provider>
  );
};

export default ReviewContext;
